import { Component, OnInit } from '@angular/core';
import { LoaderData } from './overlay-loader.config';

@Component({
  templateUrl: './overlay-loader.component.html',
})
export class OverlayLoaderComponent {
  constructor(public readonly data: LoaderData) {}

  get isSpinner(): boolean {
    return this.data.loaderType === 'spinner';
  }

  get isProgressBar(): boolean {
    return this.data.loaderType === 'progressBar';
  }
}
